import React, { useState, useEffect } from "react";

import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Footer from "./components/Footer";
import WhitepaperEmbeded from "./components/Home/whitepaper";
import Roadmap from "./components/Home/roadmap";
import SCalculator from "./components/Home/s_calculator";
import Dashboard from "./components/Dashboard/Dashboard";
import Ecosystem from "./components/Ecosystem/ecosystem";
import LumeriaRealityVerse from "./components/LumeriaRealityVerse/LumeriaRealityVerse";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";



function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/whitepaper" element = {<WhitepaperEmbeded/>} />
          <Route path="/roadmap" element={<Roadmap/>} />
          <Route path="/sovereign-calculator" element={<SCalculator/>} />
          <Route path="/test-net-dashboard" element={<Dashboard />} />
          <Route path="/ecosystem" element={<Ecosystem />} />
          <Route path="/lumeria-reality" element={<LumeriaRealityVerse />} />
          <Route path="/about" element={<About />} />
         
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
